import {
  CreateUpdateManualDto,
  CreateUpdateManualDtoFromJSON,
  DefaultApi,
  GetLastEditorDto,
  GetManualDto,
} from '../autogenerated/spdApiClient';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { validateAgainst } from '../validation/validateAgainst';
import { ManualSchema } from '../validation/schemas';
import { manualForGrid } from '../../../spd/components/Manual/ManualSearch';

export interface ManualContextInterface {
  get: (id: string) => Promise<GetManualDto>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
  create: (dto: CreateUpdateManualDto) => Promise<GetManualDto>;
  update: (id: string, dto: CreateUpdateManualDto) => Promise<GetManualDto>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
}

export const ManualContext = (api: DefaultApi): ManualContextInterface => ({
  get: (id: string) => api.manualControllerGet(id),

  getAllByPortion: async (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => {
    const data = await api.manualControllerGetAllByPortion(
      pageSize,
      pageNumber,
      orderBy || '',
      orderDirection || '',
      filterText || '',
      filterColumns,
    );
    return data.map(manualForGrid);
  },

  getAllCount: (filterText?: string, filterColumns?: string) =>
    api.manualControllerGetAllCount(filterText || '', filterColumns),

  create: (dto: CreateUpdateManualDto) => api.manualControllerCreate(dto),
  update: (id: string, dto: CreateUpdateManualDto) =>
    api.manualControllerUpdate(id, dto),
  getLastEditor: (id: string) => api.manualControllerGetLastEditor(id),
});

export const validate = (manual: CreateUpdateManualDto) =>
  validateAgainst(ManualSchema, manual);

export const manualData = (manual?: GetManualDto): CreateUpdateManualDto => {
  return CreateUpdateManualDtoFromJSON({
    ...manual,
    ...{
      testsIds: (manual?.manualTests || [])
        .map(manualTest => manualTest.test?.id)
        .filter(Boolean),
    },
  });
};
